import { render, staticRenderFns } from "./CustomPageEdit.vue?vue&type=template&id=3a3c360c&"
import script from "./CustomPageEdit.vue?vue&type=script&lang=js&"
export * from "./CustomPageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports